module.exports = __webpack_public_path__ + "img/niina.01697ac6.png";